var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 72,
    viewBox: "0 0 57 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4838 44.58C32.3208 43.113 30.1146 41.3677 29.1654 40.5585C27.4561 39.1014 25.6085 38.2292 23.4987 37.7603C22.5744 37.5549 21.406 37.7462 20.4614 37.7462C18.8408 37.7462 17.0971 37.5272 15.5259 37.9431C12.8727 38.6454 10.5971 39.9596 8.43901 41.6553C7.16085 42.6596 6.02313 43.3861 4.89556 44.58C4.11075 45.411 3.95972 46.5968 3.26445 47.4907C2.77756 48.1167 2.36453 50.2694 2.36453 51.0482C2.36453 53.0835 1.7343 55.8805 2.56139 57.7414C2.7582 58.1842 2.49866 58.6915 2.74418 59.1335C2.96087 59.5235 3.3294 60.3507 3.37694 60.7787C3.50902 61.9674 4.67593 63.1319 5.14867 64.1955C5.92573 65.9439 9.34527 68.0198 11.2231 68.1187C12.5454 68.1882 13.7731 68.6249 15.1463 68.6249C16.3883 68.6249 17.6304 68.6249 18.8725 68.6249C21.0887 68.6249 24.0186 67.1281 26.0156 66.2204C27.9681 65.3329 29.3255 63.4113 30.2621 61.538C31.4513 59.1597 32.621 56.7478 32.976 54.0855C33.2366 52.1309 33.5293 50.164 33.9462 48.236C34.3398 46.4158 33.8755 44.4553 34.2696 42.6818C34.5448 41.4436 34.291 38.939 34.291 37.626C34.291 34.8018 34.5087 36.1834 34.5087 37.9993C34.5087 40.076 34.9619 42.1206 35.0149 44.1863C35.0753 46.5448 35.0149 48.9138 35.0149 51.2732C35.0149 57.5085 34.0025 63.6813 34.0025 69.8904",
    stroke: "#FF630B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2246 1.61328C41.7067 6.91588 41.9918 12.4062 41.9918 17.7236C41.9918 24.2209 42.2832 30.8309 41.7218 37.2862C40.7693 48.24 41.736 58.9522 41.736 69.8904",
    stroke: "#B00487",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1602 36.6469C29.474 36.6469 31.9213 36.7556 34.1214 36.0786C36.3078 35.4059 39.2939 35.8797 41.5941 35.8797C44.1219 35.8797 46.5982 35.624 49.152 35.624C51.1653 35.624 53.0203 35.8797 55.0336 35.8797",
    stroke: "#B00487",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAt);
export default __webpack_public_path__ + "static/media/AT.df13abc35047ff975efe10dd8aec395b.svg";
export { ForwardRef as ReactComponent };